import React from 'react';
import { default as LogoImage } from '../assets/images/Logo.svg';

export interface LogoProps {
  link: string;
}

const Logo: React.FC<LogoProps> = ({ link = '/' }) => (
  <a href={link} className="header-logo">
    <img
      loading="lazy"
      className="w-32 h-auto sm:w-60"
      src={LogoImage as string}
      alt="Advieskeuze"
    />
  </a>
);

export default Logo;
